import * as THREE from 'three';
import GUI from 'lil-gui';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { Sky } from 'three/addons/objects/Sky.js';
import waterVertexShader from '../shaders/water/vertex.glsl?raw'; 
import waterFragmentShader from '../shaders/water/fragment.glsl?raw';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import * as CANNON from 'cannon-es';
// import CannonDebugRenderer from './utils/cannonDebugRenderer'


/**
 * Base
 */


// Debug
const gui = new GUI(
    {
        title: 'debug UI uiiuiuiu',
        closeFolders: true,
});
gui.close()
gui.hide()


window.addEventListener('keydown', (event) => {
    if(event.key == 'h')
        gui.show(!gui._hidden)
})


// global stuff
const debugObject = {}
let portfolioButtons = [];
let currentHoveredPlane = null;
let buttonFont = null;
let portfolioPlanes = []
let createPortfolioButton = null;
let buttonsCreated = false;
let aboutH1MeshGlobal = null
let sky, sun = null
let buoy = null

debugObject.waveHeight = 0.3
debugObject.waveSpeed = 1.2
debugObject.rollAmount = 0.08

    gui.add(debugObject, 'waveHeight').min(0).max(1).step(0.01).name('Wave Height')
    gui.add(debugObject, 'waveSpeed').min(0).max(5).step(0.1).name('Wave Speed')
    gui.add(debugObject, 'rollAmount').min(-0.15).max(0.15).step(0.001).name('Roll Amount')

const introOverlay = document.getElementById('intro-overlay')
const enterBtn = document.getElementById('enter-btn')


enterBtn.addEventListener('click', () => {
  introOverlay.classList.add('hide')
})


// Canvas
const canvas = document.querySelector('canvas.webgl');


// Scene
const scene = new THREE.Scene();


// // axis helper 
// const axesHelper = new THREE.AxesHelper( 5 );
// scene.add( axesHelper );


// Groups
const portfolio = new THREE.Group()
    scene.add(portfolio)



function tryCreatePortfolioButtons() {
    if (buttonsCreated) return;
    if (!createPortfolioButton) return;
    if (portfolioPlanes.length === 0) return;


    portfolioPlanes.forEach((plane, index) => {
        const url =
            index === 0 ? './sub/walkingChest.html' :
            index === 1 ? './sub/Cave.html' :
            null;


        if (!url) return;


        createPortfolioButton(url, plane.position);
    });


    buttonsCreated = true;
}


/**
 * Loaders
 */
// Texture loaders
const textureLoader = new THREE.TextureLoader();
const PortfolioImg1 = textureLoader.load('textures/portfolio1.png', (texture) => {
  texture.colorSpace = THREE.SRGBColorSpace;
});
const PortfolioImg2 = textureLoader.load('textures/portfolio3.jpg', (texture) => {
  texture.colorSpace = THREE.SRGBColorSpace;
});


// Font loader
const loader = new FontLoader();
loader.load('./fonts/Londrina Solid_Regular.json', (font) => {
    buttonFont = font;


    createPortfolioButton = (url, positionOffset) => {
    // Invisible hitbox plane (16x9 matches portfolio images)
    const hitboxGeometry = new THREE.PlaneGeometry(16, 9);
    const hitboxMaterial = new THREE.MeshBasicMaterial({
        transparent: true,
        opacity: 0,
        side: THREE.DoubleSide
    });
    const hitboxMesh = new THREE.Mesh(hitboxGeometry, hitboxMaterial);
    hitboxMesh.rotation.x = -Math.PI * 0.5;
    hitboxMesh.position.set(0, 0, 0);


    // Text (visual only, no raycasting)
    const buttonGeometry = new TextGeometry('EXPLORE', {
        font: buttonFont,
        size: 1.5,
        depth: 0.2,
        curveSegments: 12,
        bevelEnabled: false
    });
    buttonGeometry.computeBoundingBox();
    buttonGeometry.center();


    const buttonMesh = new THREE.Mesh(
        buttonGeometry,
        new THREE.MeshStandardMaterial({
            color: 0xffd700,
            emissive: 0xffffff,
            metalness: 0.8,
            roughness: 0.2
        })
    );
    buttonMesh.rotation.x = -Math.PI * 0.5;
    buttonMesh.position.set(0, 0.1, 0); 


    const group = new THREE.Group();
    group.add(hitboxMesh);     
    group.add(buttonMesh);     
    group.scale.set(0, 0, 0);
    group.position.copy(positionOffset);
    group.position.y += 1.5;

    group.userData = {
        url,
        visible: false,
        originalScale: new THREE.Vector3(1, 1, 1),
        isHitbox: true
    };


    portfolio.add(group);
    portfolioButtons.push(group);
};



    // Text items in map 
    const portfolioH1 = new TextGeometry('PORTFOLIO', {
        font: font,
        size: 2,
        depth: 0.4,    
        curveSegments: 12,
        bevelEnabled: false
    });


    const StephanieH1 = new TextGeometry('STEPHANIE DÖRR', {
        font: font,
        size: 2,
        depth: 0.4,      
        curveSegments: 12,
        bevelEnabled: false
    });


    const aboutH1 = new TextGeometry('ABOUT', {
        font: font,
        size: 2,
        depth: 0.4,      
        curveSegments: 12,
        bevelEnabled: false
    });

    const blogH1 = new TextGeometry('BLOG', {
        font: font,
        size: 2,
        depth: 0.4,      
        curveSegments: 12,
        bevelEnabled: false
    });


    const textMaterial = new THREE.MeshStandardMaterial({ color: 0xffffff });
    const portfolioMesh = new THREE.Mesh(portfolioH1, textMaterial);
    const stephanieh1Mesh = new THREE.Mesh(StephanieH1, textMaterial);
    const aboutH1Mesh = new THREE.Mesh(aboutH1, textMaterial);
    const blogH1Mesh = new THREE.Mesh(blogH1, textMaterial);


    // center geometry 
    StephanieH1.computeBoundingBox();
    StephanieH1.center();  


    // center geometry 
    portfolioH1.computeBoundingBox();
    portfolioH1.center();  


    // center geometry 
    aboutH1.computeBoundingBox();
    aboutH1.center();  

    // center geometry 
    blogH1.computeBoundingBox();
    blogH1.center();  


    portfolioMesh.position.set(10, 2, -3);


    stephanieh1Mesh.position.set(-5, -2, -4)
    stephanieh1Mesh.rotation.x -= Math.PI * 0.5
    stephanieh1Mesh.rotation.z += Math.PI * 0.25


    aboutH1Mesh.position.set(-25.5, 4.5, -25);
    aboutH1Mesh.scale.set(0.75, 0.75, 0.75);

    blogH1Mesh.position.set(20, 0, -50);
    blogH1Mesh.scale.set(0.75, 0.75, 0.75);
    blogH1Mesh.rotation.x -= Math.PI * 0.5



    portfolio.add(portfolioMesh);
    scene.add(stephanieh1Mesh);
    scene.add(aboutH1Mesh);
    scene.add(blogH1Mesh);


    aboutH1MeshGlobal = aboutH1Mesh;


    tryCreatePortfolioButtons();
});
    


// Draco Loader
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('./draco/');


// GLTF loader
const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);


let mixer = null;
let model = null; // Store reference to the loaded model
let targetPosition = null;
let targetQuaternion = new THREE.Quaternion();


// Camera offset above & behind the model
const cameraOffset = new THREE.Vector3(0, 10, 8); 
// You can adjust this later


// Lexin Ship
gltfLoader.load(
    './models/Ship/lexinSimpleUV2.glb',
    (gltf) => {
        gltf.scene.position.set(2, 2, -1);
        scene.add(gltf.scene);
        model = gltf.scene; 
        model.rotation.y += Math.PI / 2;
        model.scale.set(2,2,2)
        model.castShadow = true
        //mixer = new THREE.AnimationMixer(gltf.scene);
        // const action = mixer.clipAction(gltf.animations[0]); // Play first animation
        // action.play();
    },
)


// Lighthouse 


// texture loader
const lampTexture = textureLoader.load('./textures/emLighthouse.png', (tex) => {
    tex.colorSpace = THREE.SRGBColorSpace
});


//Lighthouse model


gltfLoader.load('./models/Buildings/lighthouse5.glb', (gltf) => {
    const lighthouse = gltf.scene;
    lighthouse.position.set(20, -3, -50);
    lighthouse.scale.set(4, 4, 4);
    // lighthouse .rotation.y += Math.PI;
    scene.add(lighthouse);


    mixer = new THREE.AnimationMixer(gltf.scene);
    const action = mixer.clipAction(gltf.animations[0]); 
    action.play();

// hitbox 
 const lighthouseHitbox = new THREE.Mesh(
                new THREE.BoxGeometry(8, 2, 8),
                new THREE.MeshBasicMaterial({
                    transparent: true,
                    opacity: 0
                })
            )
            lighthouseHitbox.position.set(20, 1, -50)
            lighthouseHitbox.userData = {url: './sub/blog.html'}
            scene.add(lighthouseHitbox)


  // find children
  lighthouse.traverse((child) => {
    if (child.isMesh) console.log('MESH FOUND:', child.name);

  });


  // lamp lighthouse child 
  const lampLighthouse = lighthouse.getObjectByName('lamp');
  if (lampLighthouse && lampLighthouse.isMesh) {
    lampLighthouse.material = new THREE.MeshStandardMaterial({
      map: lampTexture,
      emissiveMap: lampTexture,
      emissive: new THREE.Color(0xffff00),
      emissiveIntensity: 2,
      roughness: 0.3
    });
  }


  // glass child
  const glassLighthouse = lighthouse.getObjectByName('glass');
  if (glassLighthouse && glassLighthouse.isMesh) {
    glassLighthouse.material = new THREE.MeshPhysicalMaterial({
      transmission: 1,
      ior: 1.5,
      thickness: 1,
      roughness: 0.05,
      metalness: 0,
      envMapIntensity: 1,  
      clearcoat: 1,
      clearcoatRoughness: 0
    });
  }
});




//Foliage 3D
const foliage = new THREE.Group()
scene.add(foliage)
foliage.scale.set(2, 2, 2)
foliage.position.set(0, 0, 4)


gltfLoader.load(
    './models/Foliage/Foliage2.glb',
    (gltf) => {
        gltf.scene.position.set(2, -1, -1);
        foliage.add(gltf.scene);
        // mixer = new THREE.AnimationMixer(gltf.scene);
        // const action = mixer.clipAction(gltf.animations[0]); // Play first animation
        // action.play();
  });


  gltfLoader.load(
    './models/Foliage/Foliage3.glb',
    (gltf) => {
        gltf.scene.position.set(0, -1, 4);
        gltf.scene.scale.set(1.5, 1.5, 1.5)
        foliage.add(gltf.scene);
        // mixer = new THREE.AnimationMixer(gltf.scene);
        // const action = mixer.clipAction(gltf.animations[0]); // Play first animation
        // action.play();
  });


  gltfLoader.load(
    './models/Foliage/Foliage1.glb',
    (gltf) => {
        gltf.scene.name = 'foliage1'
        gltf.scene.position.set(-2, -1, -1);
        foliage.add(gltf.scene);
        // mixer = new THREE.AnimationMixer(gltf.scene);
        // const action = mixer.clipAction(gltf.animations[0]); // Play first animation
        // action.play();
  });

// scattered foliage

const foliageModels = [
    './models/Foliage/Foliage1.glb',
    './models/Foliage/Foliage2.glb', 
    './models/Foliage/Foliage3.glb'
];

for (let i = 0; i < 20; i++) {  
    const modelIndex = Math.floor(Math.random() * foliageModels.length);
    const modelPath = foliageModels[modelIndex];
    
    gltfLoader.load(modelPath, (gltf) => {
        const foliageInstance = gltf.scene.clone();  // Clone for multiples
        
        // CIRCULAR SCATTER around map center (0,0)
        const angle = Math.random() * Math.PI * 8;
        const radius = 15 + Math.random() * 25;  // 15-40 units from center
        const x = Math.cos(angle) * radius;
        const z = Math.sin(angle) * radius;
        
        // Random rotation & slight size variation
        foliageInstance.rotation.y = Math.random() * Math.PI * 2;
        foliageInstance.scale.setScalar(1.6 - Math.random() * 0.8);  
        foliageInstance.position.set(x, -1, z);
        
        foliage.add(foliageInstance);
    });
}


  // about island 
    gltfLoader.load(
        './models/Buildings/aboutIsland.glb',
        (gltf) => {
            gltf.scene.name = 'aboutIle'
            gltf.scene.position.set(-20,-2,-30);
            scene.add(gltf.scene);
            gltf.scene.scale.set(4,4,4)
            // gltf.scene.rotation.y += Math.PI * 0.5;

            const islandHitbox = new THREE.Mesh(
                new THREE.BoxGeometry(20, 14, 18),
                new THREE.MeshBasicMaterial({
                    transparent: true,
                    opacity: 0
                })
            )
            islandHitbox.position.set(-20, 2, -30)
            islandHitbox.userData = {url: './sub/about.html'}
            scene.add(islandHitbox)
        })


  // Buoy
    gltfLoader.load(
    './models/Environment/buoy2.glb',
    (gltf) => {
        buoy =  gltf.scene;
        gltf.scene.name = 'buoy'
        gltf.scene.position.set(10,-1.5,3);
        portfolio.add(buoy);
//         mixer = new THREE.AnimationMixer(gltf.scene);
//         const action = mixer.clipAction(gltf.animations[0]);
//         action.play();
  });


  // Portfolio Projects 
    portfolio.scale.set(1,1,1)
    portfolio.position.set(20, 0, -10)
    portfolio.rotation.y -= Math.PI * 0.25


  const Portfolio1 = new THREE.Mesh(
    new THREE.PlaneGeometry (16,9),
    new THREE.MeshStandardMaterial({map: PortfolioImg1}))
  Portfolio1.position.set(0,-1,0)
  Portfolio1.rotation.x -= Math.PI * 0.5
  portfolio.add(Portfolio1)
  portfolioPlanes.push(Portfolio1)
    tryCreatePortfolioButtons();


  const Portfolio2 = new THREE.Mesh(
    new THREE.PlaneGeometry (16,9),
    new THREE.MeshStandardMaterial({map: PortfolioImg2}))
  Portfolio2.position.set(20,-1,0)
  Portfolio2.rotation.x -= Math.PI * 0.5
  portfolio.add(Portfolio2)
  portfolioPlanes.push(Portfolio2);
    tryCreatePortfolioButtons();

// /**
//  * Floor
//  */
// const floor = new THREE.Mesh(
//     new THREE.PlaneGeometry(1000, 1000),
//     new THREE.MeshStandardMaterial({
//         color: '#204e69',
//         metalness: 0,
//         roughness: 0.3
//     })
// );
// floor.receiveShadow = true;
// floor.position.set(0, -1, 0);
// floor.rotation.x = - Math.PI * 0.5;
// scene.add(floor);


/**
 * PHYSICS
 */
// world
const world = new CANNON.World()
world.broadphase = new CANNON.SAPBroadphase(world)
world.allowSleep = true
world.gravity.set(0,-9.82,0)

// floor
const floorShape = new CANNON.Plane()
const floorBody = new CANNON.Body()
floorBody.mass = 0 
floorBody.addShape(floorShape)
floorBody.quaternion.setFromAxisAngle(
    new CANNON.Vec3(-1, 0, 0),
    Math.PI * 0.5
)
world.addBody(floorBody)


// boat physics body 
const boatShape = new CANNON.Box(new CANNON.Vec3(1, 1, 3))
const boatBody = new CANNON.Body({
    mass: 1,
    shape: boatShape
})


// boatBody.position.set = model.position.copy 



/**
 * WATER plane
 */
// Geometry
const waterGeometry = new THREE.PlaneGeometry(200, 200, 512, 512)


// Color
debugObject.depthColor = '#1169ac'
debugObject.surfaceColor = '#43a3b6'
debugObject.fogColor = '#edf2fd'


// Material
const waterMaterial = new THREE.ShaderMaterial({
    vertexShader: waterVertexShader,
    fragmentShader: waterFragmentShader,
    uniforms:
    {
        //Big wave
        uTime: { value: 0 },
      uBigWavesElevation: { value: 0.131 },
      uBigWavesFrequency: { value: new THREE.Vector2(0.1, 0.05) } , 
      uBigWavesSpeed: { value: 0.75},


      // small wave 
       uSmallWavesElevation: { value: 0.189 },
       uSmallWavesFrequency: { value: 0.1615 },
       uSmallWavesSpeed: { value: 0.362 },
       uSmallWavesIterations: { value: 4 },


      //color
      uDepthColor: { value: new THREE.Color(debugObject.depthColor)},
      uSurfaceColor: { value: new THREE.Color(debugObject.surfaceColor)},
      uColorOffset: { value: 0.08},
      uColorMultiplier: { value: 5},


      // Fog 
      uFogColor: { value: new THREE.Color(0xc4e8fd)},
      uFogNear: { value: 25.0},
      uFogFar: { value: 60.0},
      uCameraPosition: { value: new THREE.Vector3() }
    }
})


// Debug
// Big waves debug
gui
    .add(waterMaterial.uniforms.uBigWavesElevation, 'value')
    .min(0)
    .max(0.5)
    .step(0.001)
    .name('uBigWavesElevation')


gui
    .add(waterMaterial.uniforms.uBigWavesFrequency.value, 'x')
    .min(0)
    .max(1)
    .step(0.0001)
    .name('uBigWavesFrequencyX')


gui
    .add(waterMaterial.uniforms.uBigWavesFrequency.value, 'y')
    .min(0)
    .max(1)
    .step(0.001)
    .name('uBigWavesFrequencyY')


gui
.add(waterMaterial.uniforms.uBigWavesSpeed, 'value')
.min(0)
.max(4)
.step(0.001)
.name('uBigWavesSpeed')


// Color debug
gui
.addColor(debugObject, 'depthColor')
.name('depthColor')
.onChange(() =>
{
    waterMaterial.uniforms.uDepthColor.value.set(debugObject.depthColor)
})


gui
.addColor(debugObject, 'surfaceColor')
.name('surfaceColor')
.onChange(() =>
{
    waterMaterial.uniforms.uSurfaceColor.value.set(debugObject.surfaceColor)
})


gui
    .add(waterMaterial.uniforms.uColorOffset, 'value')
    .min(0)
    .max(1)
    .step(0.001)
    .name('uColorOffset')


gui
    .add(waterMaterial.uniforms.uColorMultiplier, 'value')
    .min(0)
    .max(10)
    .step(0.001)
    .name('uColorMultiplier')


    //small waves debug
gui
    .add(waterMaterial.uniforms.uSmallWavesElevation, 'value')
    .min(0)
    .max(1)
    .step(0.001)
    .name('uSmallWavesElevation')


gui
    .add(waterMaterial.uniforms.uSmallWavesFrequency, 'value')
    .min(0)
    .max(1)
    .step(0.0001)
    .name('uSmallWavesFrequency')


gui
    .add(waterMaterial.uniforms.uSmallWavesSpeed, 'value')
    .min(0)
    .max(4)
    .step(0.001)
    .name('uSmallWavesSpeed')


gui
    .add(waterMaterial.uniforms.uSmallWavesIterations, 'value')
    .min(0)
    .max(4)
    .step(1)
    .name('uSmallWavesIterations')


// Fog debug
gui
    .add(waterMaterial.uniforms.uFogFar, 'value')
    .min(0)
    .max(100)
    .step(0.001)
    .name('uFogFar')


gui
    .add(waterMaterial.uniforms.uFogNear, 'value')
    .min(0)
    .max(50)
    .step(0.001)
    .name('uFogNear')


gui
    .addColor(debugObject, 'fogColor')
    .name('fogColor')
    .onChange(() =>
    {
        waterMaterial.uniforms.uFogColor.value.set(debugObject.fogColor)
    })


// Water mesh
const water = new THREE.Mesh(waterGeometry, waterMaterial)
water.rotation.x = - Math.PI * 0.5
water.position.y = -2;
water.receiveShadow = true;
scene.add(water)



/**
 * Lights
 */
const hemisphereLight = new THREE.HemisphereLight(0xfcba03, 0x1a3387, 1);
scene.add(hemisphereLight);
gui.add(hemisphereLight, 'intensity').min(0).max(5).step(0.01).name('hemisphere Light');


const ambientLight = new THREE.AmbientLight(0xffffff, 1);
scene.add(ambientLight);
gui.add(ambientLight, 'intensity').min(0).max(5).step(0.01).name('ambient Light');


const directionalLight = new THREE.DirectionalLight(0xffffff, 4);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.set(1024, 1024);
directionalLight.shadow.camera.far = 15;
directionalLight.shadow.camera.left = - 7;
directionalLight.shadow.camera.top = 7;
directionalLight.shadow.camera.right = 7;
directionalLight.shadow.camera.bottom = - 7;
directionalLight.position.set(- 5, 5, 0);
scene.add(directionalLight);
gui.add(directionalLight, 'intensity').min(0).max(10).step(0.01).name('directional Light');

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};


window.addEventListener('resize', () => {
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;


    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();


    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(85, sizes.width / sizes.height, 0.1, 100);
camera.position.set(2, 2, 2);
scene.add(camera);

// // Controls
// const controls = new OrbitControls(camera, canvas);
// controls.target.set(0, 0.75, 0);
// controls.enableDamping = true;


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputColorSpace = THREE.SRGBColorSpace

renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 0.6;
renderer.outputColorSpace = THREE.SRGBColorSpace;



// Sky
sky = new Sky()
sky.scale.setScalar(450000)
scene.add(sky)

sun = new THREE.Vector3();

const guiChanged = () => {
    // Update sun position from elevation/azimuth
    const phi = THREE.MathUtils.degToRad(90 - effectController.elevation);
    const theta = THREE.MathUtils.degToRad(effectController.azimuth);
    
    sun.setFromSphericalCoords(1, phi, theta);

    sky.material.uniforms['sunPosition'].value.copy(sun);
    
    // Update sky parameters
    sky.material.uniforms['turbidity'].value = effectController.turbidity;
    sky.material.uniforms['rayleigh'].value = effectController.rayleigh;
    sky.material.uniforms['mieCoefficient'].value = effectController.mieCoefficient;
    sky.material.uniforms['mieDirectionalG'].value = effectController.mieDirectionalG;
    
    // Update exposure
    renderer.toneMappingExposure = effectController.exposure;
};

const effectController = {
					turbidity: 1.5,
					rayleigh: 0.8,
					mieCoefficient: 0.001,
					mieDirectionalG: 0.7,
					elevation: 65,
					azimuth: 180,
					exposure: renderer.toneMappingExposure
				};

const phi = THREE.MathUtils.degToRad( 90 - effectController.elevation );
					const theta = THREE.MathUtils.degToRad( effectController.azimuth );

					sun.setFromSphericalCoords( 1, phi, theta );

gui.add( effectController, 'turbidity', 0.0, 20.0, 0.1 ).onChange( guiChanged);
				gui.add( effectController, 'rayleigh', 0.0, 4, 0.001 ).onChange( guiChanged );
				gui.add( effectController, 'mieCoefficient', 0.0, 0.1, 0.001 ).onChange( guiChanged );
				gui.add( effectController, 'mieDirectionalG', 0.0, 1, 0.001 ).onChange( guiChanged );
				gui.add( effectController, 'elevation', 0, 90, 0.1 ).onChange( guiChanged );
				gui.add( effectController, 'azimuth', - 180, 180, 0.1 ).onChange( guiChanged );
				gui.add( effectController, 'exposure', 0, 1, 0.0001 ).onChange( guiChanged );
guiChanged();

 // Fog
scene.fog = new THREE.FogExp2('#c4e8fd', 0.03)

/**
 * Pointer
 */
canvas.addEventListener('pointerdown', (event) => {
    const mouse = new THREE.Vector2();
    mouse.x = (event.clientX / sizes.width) * 2 - 1;
    mouse.y = - (event.clientY / sizes.height) * 2 + 1;


    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, camera);


    // portfolio buttons
    const buttonIntersects = raycaster.intersectObjects(portfolioButtons, true)
    if (buttonIntersects.length > 0) {
        const clickedObject = buttonIntersects[0].object
        const group = clickedObject.parent || clickedObject
        if(group.userData.visible && group.userData.url) {
            window.open(group.userData.url, '_self')
            return
        }
    }

// about island click
    scene.traverse((child) => {
            if (child.userData.url && child.userData.url.includes('about.html')) {
                const islandIntersects = raycaster.intersectObject(child)
                if (islandIntersects.length > 0) {
                    window.open(child.userData.url, '_self')
                    return
                }
            }
        })

// lighthouse island click
    scene.traverse((child) => {
            if (child.userData.url && child.userData.url.includes('blog.html')) {
                const blogIntersects = raycaster.intersectObject(child)
                if (blogIntersects.length > 0) {
                    window.open(child.userData.url, '_self')
                    return
                }
            }
    })

//     // about button
//     if (aboutH1MeshGlobal) {
//         const aboutIntersects = raycaster.intersectObject(aboutH1MeshGlobal, true)
//         if (aboutIntersects.length > 0) {
//             window.open('./sub/about.html', '_self')
//             return
//   }
// }

    // boat mouse click
    const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0); // Floor is y=0
    const intersection = new THREE.Vector3();
    raycaster.ray.intersectPlane(plane, intersection);


    if (model) {
        targetPosition = intersection.clone();


// direction 
        const direction = new THREE.Vector3(
            targetPosition.x - model.position.x,
            0,
            targetPosition.z - model.position.z
        ).normalize();



        targetQuaternion.setFromUnitVectors(new THREE.Vector3(0, 0, 1), direction);


        const rotationOffset = new THREE.Quaternion();
        rotationOffset.setFromAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI / 2);


        targetQuaternion.multiply(rotationOffset); 
    }
});


/**
 * Animation Loop
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
    const elapsedTime = clock.getElapsedTime();
    const deltaTime = elapsedTime - previousTime;
    previousTime = elapsedTime;
    // console.log(deltaTime)

    // Physics debug
    // const cannonDebugRenderer = new CannonDebugRenderer(scene, world)


    if (mixer) {
        mixer.update(deltaTime);
    }

/**
 * Ship movement
 */
    
    if (model && targetPosition) {
       
        model.position.lerp(targetPosition, 0.02);
        model.quaternion.slerp(targetQuaternion, 0.05);
    }

/**
 * Camera movement
 */
    if (model) {
    const modelPos = new THREE.Vector3();
    model.getWorldPosition(modelPos);

    // camera position track
    const desiredCameraPos = modelPos.clone().add(cameraOffset);

    const smoothFactor = 1.5 * deltaTime; 

    camera.position.x += (desiredCameraPos.x - camera.position.x) * smoothFactor;
    camera.position.y += (desiredCameraPos.y - camera.position.y) * smoothFactor;
    camera.position.z += (desiredCameraPos.z - camera.position.z) * smoothFactor;

    
    const lookTarget = modelPos.clone();
    lookTarget.y += 1; 

    // bobbing animation 
    const waveTime = elapsedTime * 1.2

    const bobHeight = Math.sin(waveTime * debugObject.waveSpeed) * debugObject.waveHeight+ Math.sin(waveTime * 2.5) * (debugObject.waveHeight * 0.3)

    // const bobRoll = Math.sin(waveTime * 0.1) * debugObject.rollAmount

    model.position.y = bobHeight
    // model.rotation.x = bobRoll

    camera.lookAt(lookTarget);
    }

if (buoy) {
        const buoyWaveTime = elapsedTime * 1.0 + 1.6
        const buoyBobHeight = Math.sin(buoyWaveTime * 1.5) * 0.2 + Math.sin(buoyWaveTime * 3.0) * 0.1;
        const bobRoll = Math.sin(buoyWaveTime * 0.1) * 0.2
        buoy.rotation.x = bobRoll
        buoy.rotation.z = Math.sin(elapsedTime * 0.8) * 0.1

        buoy.position.y = -1.5 + buoyBobHeight;
}

    /**
     * Waves animation
     */
    // Update Water
    waterMaterial.uniforms.uTime.value = elapsedTime
    waterMaterial.uniforms.uCameraPosition.value.copy(camera.position);

    // // Physics animation 
    // world.fixedStep()

    // button hover intersection
    if (model) {
        portfolioButtons.forEach((buttonGroup, index) => {
            const plane = portfolioPlanes[index]
            const planeWorldPos = new THREE.Vector3();
            plane.getWorldPosition(planeWorldPos);


            const modelWorldPos = new THREE.Vector3();
            model.getWorldPosition(modelWorldPos);


            const distance = modelWorldPos.distanceTo(planeWorldPos);


            const buttonMesh = buttonGroup.children[1]


            if (distance < 6) {
                buttonGroup.userData.visible = true
                currentHoveredPlane = plane

                // Animation fade in
                buttonGroup.scale.lerp(buttonGroup.userData.originalScale, 0.1)
            } else {
                buttonGroup.userData.visible = false;

                //Animate fade out
                buttonGroup.scale.lerp(new THREE.Vector3(0, 0, 0), 0.1);
                if (buttonGroup.scale.x < 0.1) {
                    buttonGroup.scale.set(0,0,0)
                }
            }
        })
    }


    renderer.render(scene, camera);
    requestAnimationFrame(tick);


};


tick();